module.exports = __webpack_public_path__ + "static/media/netflix.5f6c07ce.png";